import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCreateAnnouncement } from "./useCreateAnnouncement.request";

const useCreateAnnouncement = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateAnnouncement,
    ...options
  });
};

export default useCreateAnnouncement;
